<section class="card min-h-full">
  <!-- header -->
  <h2 class="flex items-center gap-3">
    <span class="material-symbols-rounded text-accent-600"
      >network_intelligence</span
    >
    Agentes I.A.
    <button
      class="ml-auto tertiary !px-1 md:!px-3"
      [routerLink]="[{ outlets: { modal: ['add', ''] } }]">
      <span class="material-symbols-rounded m-auto text-black/60"> add </span>
      @if (sharedService.screenSize !== 's') {
        Adicionar
      }
    </button>
  </h2>

  <!-- body -->
  @if (agentsService.agents.length > 0) {
    <p class="text-balance text-black/60">
      Crie agentes e os configure para automatizar tarefas e processos. Um
      agente pode ser associado a um ou mais números.
      <a
        href="https://home.blu.direct/blog/como-usar-o-recurso-de-agentes-ia-no-blu"
        target="_blank"
        class="font-bold text-accent-600"
        >Saiba mais</a
      >
    </p>
    <kor-table readonly columns="1fr auto auto">
      <kor-table-row slot="header">
        <kor-table-cell head>Nome</kor-table-cell>
        <kor-table-cell head></kor-table-cell>
        <kor-table-cell head></kor-table-cell>
      </kor-table-row>
      @for (agent of agentsService.agents; track agent) {
        <kor-table-row>
          <kor-table-cell>
            <b>{{ agent.name }}</b>
          </kor-table-cell>
          <kor-table-cell>
            <button class="secondary px-1">
              <span
                class="material-symbols-rounded"
                [routerLink]="['/admin/chat/agents', agent.uid]">
                edit
              </span>
            </button>
          </kor-table-cell>
        </kor-table-row>
      }
    </kor-table>
  } @else {
    <!-- empty state -->
    <div
      class="max-w-80 min-h-80 text-center flex flex-col items-center gap-4 justify-center m-auto">
      <h1>Crie seu primeiro agente</h1>
      <p class="leading-snug text-black/60">
        Crie agentes para automatizar tarefas e processos. Agentes podem ser
        associados a um ou mais números.
      </p>

      <a
        href="https://home.blu.direct/blog/como-usar-o-recurso-de-agentes-ia-no-blu"
        target="_blank"
        class="no-underline">
        <button class="secondary">Saiba mais</button>
      </a>
    </div>
  }
</section>

<!-- modals -->
<router-outlet name="modal"></router-outlet>
